import { create } from "zustand";

/**
 * Dev-only: timings for the most recent CSK rotation per chat.
 * Populated by `rotateCSK` (middleware/chats.ts), read by DebugPanel.
 * All durations are milliseconds.
 */
export type RotationTimings = {
  members: number;
  decryptPrivateKey: number;
  generateCSK: number;
  encapsulateAll: number; // sum across all members
  serverPost: number;
  selfEncapsulate: number;
  total: number;
  at: number; // wall-clock ms when finished
};

type State = {
  byChat: Record<string, RotationTimings>;
  recordRotation: (chatId: string, timings: RotationTimings) => void;
};

export const useDebugRotationState = create<State>()((set) => ({
  byChat: {},
  recordRotation: (chatId, timings) =>
    set((s) => ({ byChat: { ...s.byChat, [chatId]: timings } })),
}));
